import { createMutation } from '@/mutations'
import { createPerson, deletePerson, updatePerson } from '@/features/profile/api/people'
import type { Person, PersonPayload } from '@/types/people'

const PEOPLE_KEY = ['people']

export const useCreatePersonMutation = () => {
  return createMutation<Person, PersonPayload>({
    mutationFn: (payload) => createPerson(payload),
    invalidateQueries: [PEOPLE_KEY],
  })
}

export const useUpdatePersonMutation = () => {
  return createMutation<Person, { id: number; payload: PersonPayload }>({
    mutationFn: ({ id, payload }) => updatePerson(id, payload),
    invalidateQueries: [PEOPLE_KEY],
  })
}

export const useDeletePersonMutation = () => {
  return createMutation<void, number>({
    mutationFn: (id) => deletePerson(id),
    invalidateQueries: [PEOPLE_KEY],
  })
}
